export const contact_method = {
  type: {
    internal: 'Internal',
    external: 'Eksternal',
    sip: 'SIP-akun'
  },

  label: {
    home: 'Rumah',
    work: 'Pekerjaan',
    office: 'Kantor'
  }
};
